function initLoader() {
    showLoader = function(url) {
        tl = new TimelineLite();
        tl.pause();
        tl.add([
            // On peut chainer les évènements TweenMax ici. Example :
            // TweenMax.fromTo( $('.pan'), 0.4, { x: '100%' }, { x: '0%', delay: 0 } )
        ]);
        tl.call(function() {
            $(window).scrollTop(0);
            if( pageAjax ){
                // Chargement de la page via Barba
                promise.newContainerLoading.then(promise.showloader.bind(promise));
            }else{
                // A la fin de l'anim, on redirige vers la nouvelle URLs
                window.location.href = url;
            }
        });
        tl.play();
    };

    hideLoader = function() {
        // On lance l'animation de révélation de la page
        tl = new TimelineLite();
        tl.pause();
        tl.call(function() {
            // initScrollAnimations();
        });
        tl.add([
            // On peut chainer les évènements TweenMax ici. Example :
            // TweenMax.fromTo( $('.pan'), 0.4, { x: '0%' }, { x: '100%', delay: 0 } )
        ], [], this, 1);
        tl.play();
    };
}